import { createAuthServices } from '../modules/auth/application/auth-services';
import { httpAuthRepository } from '../modules/auth/infrastructure/api/http-auth-repository';
import { createApiClientSession } from '../modules/auth/infrastructure/session/api-client-session-factory';

export const authServices = createAuthServices({
  authRepository: httpAuthRepository,
  createSession: createApiClientSession,
});
